import React from "react";
import ChatBot from "../components/ChatBot";

const AIChatBot = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "radial-gradient(ellipse at top left, #f8fafc 0%, #eff6ff 45%, #dbeafe 100%)",
        padding: "30px 20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ChatBot />
    </div>
  );
};

export default AIChatBot;